import { useContext } from 'react';
import {
  BodyContainer,
  CardMediumContainer,
  EditedMark,
  HoverButtons,
  ItemContainer,
  TitleContainer,
} from './styles';
import positive from '../../../../assets/icons/positive.svg';
import negative from '../../../../assets/icons/negative.svg';
import warning from '../../../../assets/icons/warning.svg';
import editedMark from '../../../../assets/icons/edited-mark.svg';
import automatedMark from '../../../../assets/icons/lightning.svg';
import { canApprove } from '../../../../utils/canApprove';
import { CustomButton } from '../CardSmall/styles';
// eslint-disable-next-line import/no-cycle
import { CardContext } from '../../Approver';

interface ICardMedium {
  cardData: any;
}

const CardMedium = ({ cardData }: ICardMedium) => {
  const context: any = useContext(CardContext);
  const { handleEditCard, approval, automatedCardIds = [] } = context;
  const { id, approved, edited, data } = cardData;
  const { title, description, values } = data;
  let imageStatus = null;
  const role = localStorage.getItem('ROL');

  switch (approved) {
    case 'positive':
      imageStatus = positive;
      break;

    case 'negative':
      imageStatus = negative;
      break;

    case 'warning':
      imageStatus = warning;
      break;

    default:
      imageStatus = positive;
      break;
  }

  return (
    <CardMediumContainer>
      {edited && (
        <EditedMark>
          <img src={editedMark} alt="" width={24} height={24} />
        </EditedMark>
      )}
      <TitleContainer>
        <div className="title">{title}</div>
        <div className="icons-right">
          <img src={imageStatus} alt={imageStatus} width={24} height={24} />
          {automatedCardIds.includes(id) && (
            <img src={automatedMark} alt="automated" data-testid="automated-mark" width={16} height={16} />
          )}
        </div>
      </TitleContainer>
      <BodyContainer>
        {values &&
          values.map((item: any) => {
            return (
              <ItemContainer key={`medium${item.value}${id}`}>
                <div className="title">{item.title}</div>
                <div className="value">{item.value}</div>
              </ItemContainer>
            );
          })}
        {description && (
          <ItemContainer>
            <div className="description">{description}</div>
          </ItemContainer>
        )}
      </BodyContainer>
      <HoverButtons className="hover-buttons">
        <div className="buttons">
          <CustomButton
            className={`${
              !canApprove(role) || !approval.editable ? 'disabled' : ''
            }`}
            onClick={() => {
              if (canApprove(role) && approval.editable) {
                handleEditCard(id, data);
              }
            }}
            data-testid="edit-button"
          >
            <span className="text">Editar</span>
          </CustomButton>
        </div>
      </HoverButtons>
    </CardMediumContainer>
  );
};

export default CardMedium;
